import {ObjectUtils} from "../../../utils/data/ObjectUtils";
import {PopupWindowV5} from "./PopupWindowV5";

/**
 * Can be used as an alternative for `alert("alertMessage");`
 */
export class WarningWindowV5 extends PopupWindowV5<boolean | null> {
	protected static override readonly _defaultConfig = {
		ok: "OK",
		cancel: null as string,
		backdrop: true,
	};
	protected _okValue = true;
	protected _cancelValue = false;

	constructor(message: string, title: string, config: {ok?: string; backdrop?: boolean} = {}) {
		super({
			title: title,
			message: message,
			config: ObjectUtils.mergeConfig(WarningWindowV5._defaultConfig, config),
		});
	}

	public static open(message: string, title: string = "Warning", config?: {ok: string; backdrop: boolean}) {
		return new WarningWindowV5(message, title, config).open();
	}
}
